<template>
  <div>
    <!-- <van-nav-bar title="切换账号" left-text="返回" left-arrow @click-left="onClickLeft"/> -->
    <van-radio-group v-model="radio">
      <van-cell-group>
        <van-cell  v-for="(item, index) in list" :key="index" clickable @click="radioChange(index)">
          <template #title>
            <span class="custom-title">用户名：</span>
            <span class="custom-title">{{item.userName}}</span>
            <van-tag v-if="$store.state.userName + '' === item.userName" type="danger">当前账号</van-tag>
          </template>
          <template #right-icon>
            <van-radio :name="index" />
          </template>
        </van-cell>
      </van-cell-group>
    </van-radio-group>
    <div class="btns">
      <van-button type="info" block round @click="switchAccountBtn">切换账号</van-button>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant'
import { WechatLogin } from '@/api/login.js'
// import { signOut } from '@/api/user.js'
export default {
  name: 'switchAccount',
  components: {},
  props: {
  },
  data () {
    return {
      oldradio: 9999,
      radio: 99999,
      list: []
    }
  },
  watch: {},
  computed: {
  },
  methods: {
    // onClickLeft () { this.$router.go(-1) },
    getFirstList () {
      this.list = this.$store.state.accountList
      const that = this
      this.list.forEach((item, index) => {
        if (item.userName === that.$store.state.userName + '') {
          this.oldradio = index
          this.radio = index
        }
      })
    },
    radioChange (e) {
      this.radio = e
    },
    switchAccountBtn () {
      if (this.oldradio === this.radio && this.list[this.radio].userId === this.$store.state.userID) return this.$toast.fail('账号正登录中')
      Dialog.confirm({
        title: '温馨提示',
        message: '是否切换账号'
      }).then(async () => {
        // on confirm
        // await signOut({ token: this.$store.state.token, userId: this.$store.state.userID.split('a')[0], isAuto: '1' })
        const { data: ress } = await WechatLogin({ openId: this.$store.state.openId, userId: this.list[this.radio].userId })
        if (!ress.length) return this.$toast.fail('切换失败')
        this.$store.commit('setUserID', ress[this.radio].userId + 'a')
        this.$store.commit('setToken', ress[this.radio].token)
        this.$store.commit('setUserName', ress[this.radio].userName)
        this.$store.commit('setFirstLogin', ress[this.radio].firstLogin)
        this.$toast.success('切换账号成功')
        if (ress[this.radio].firstLogin === '0') {
          this.$router.push('/firstLoginPage')
        } else {
          this.$router.push({ name: 'User' })
        }
      }).catch(() => {
        this.radio = this.oldradio
        this.$toast('取消切换账号')
      })
    }
  },
  beforeCreate () {},
  created () {
    this.getFirstList()
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  .van-cell-group {
    .van-cell:first-child {
      padding-top: 45px;
    }
  }
  /deep/.van-tag {
    margin-left: 15px;
  }
  .btns {
    width: 100%;
    box-sizing: border-box;
    position: absolute;
    bottom: 35px;
    padding: 0 30px;
  }
</style>
